import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api, formatError, formatNZD, imageUrl } from "@/lib/api";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { nzDate } from "@/components/app/PlanCard";

const STATUS = { awaiting_approval: "Awaiting approval", live: "Live", expired: "Ended", rejected: "Not approved (refunded)", removed: "Removed", pending_payment: "Payment not completed" };

export default function BannerReport() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [b, setB] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/banners/${id}/report`, { params: { token } }).then((r) => setB(r.data)).catch(() => setB(false));
  }, [id, token]);
  const renew = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/banners/${id}/renew`, { origin_url: window.location.origin }, { params: { token } }); window.location.href = data.checkout_url; }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); setBusy(false); }
  };
  if (b === false) return <div className="max-w-xl mx-auto p-10 text-center text-slate-600" data-testid="banner-report-missing">This banner link isn&apos;t valid.</div>;
  if (!b) return <div className="p-10 text-center text-slate-500">Loading…</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-5">
      <div className="flex items-center gap-3 flex-wrap">
        <h1 className="text-3xl font-display font-extrabold" data-testid="banner-report-title">{b.business_name}</h1>
        <Badge className="bg-emerald-700 hover:bg-emerald-700" data-testid="banner-report-status">{STATUS[b.status] || b.status}</Badge>
      </div>
      <img src={imageUrl(b.image_path)} alt="" className="w-full h-40 object-cover rounded-2xl border" />
      <div className="text-sm text-slate-600">{b.period === "week" ? "Weekly" : "Monthly"} banner{b.starts_at && ` · started ${nzDate(b.starts_at)}`}{b.ends_at && ` · ends ${nzDate(b.ends_at)}`}</div>
      <Card><CardContent className="pt-5">
        <table className="w-full text-sm" data-testid="banner-report-stats">
          <thead><tr className="text-[10px] uppercase tracking-widest text-slate-500"><th className="text-left pb-2">Where</th><th className="text-right pb-2">Views</th><th className="text-right pb-2">Clicks</th></tr></thead>
          <tbody>{b.placements.map((p) => {
            const s = b.stats?.[b.placement_keys[p]] || {};
            return <tr key={p} className="border-t border-slate-100"><td className="py-1.5">{p === "HQ" ? "markdowns.nz" : p}</td><td className="text-right">{s.views || 0}</td><td className="text-right">{s.clicks || 0}</td></tr>;
          })}</tbody>
        </table>
      </CardContent></Card>
      {b.can_renew && <Button onClick={renew} disabled={busy} className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-white" data-testid="banner-renew">{busy ? "Opening Stripe…" : `Renew for another ${b.period} · ${formatNZD(b.renew_price)}`}</Button>}
    </div>
  );
}
